import React, { useEffect, useRef, lazy, Suspense } from 'react';
import './SpinResultModal.css';

const SpineWinEffect = lazy(() => import('./SpineWinEffect'));

/**
 * 抽獎結果彈窗 - 高端儀式感設計
 * 中獎時使用 Pixi.js + Spine bigwin 動畫
 */
function SpinResultModal({ result, playerInfo, onClose, audioCtx }) {
  const modalRef = useRef(null);
  const isWin = result.resultType === 'win';
  const formData = playerInfo?.formData || {};

  // 遮蔽身分證字號中間部分
  const maskId = (id) => {
    if (!id || id.length < 4) return id || '';
    return id.slice(0, 3) + '****' + id.slice(-3);
  };

  // 防止背景捲動
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  // ESC 關閉
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  if (isWin) {
    return (
      <div className="result-overlay fade-in" onClick={onClose}>
        <div
          className="result-modal win spine-win-modal"
          onClick={e => e.stopPropagation()}
          ref={modalRef}
        >
          {/* Spine 動畫背景 */}
          <div className="spine-canvas-layer">
            <Suspense fallback={null}>
              <SpineWinEffect
                prizeName={result.displayLabel}
                winnerName={formData.name || playerInfo?.player?.name || ''}
                winnerId={formData.nationalId || playerInfo?.player?.nationalId || ''}
                audioCtx={audioCtx}
              />
            </Suspense>
          </div>

          {/* HTML 內容疊加層 */}
          <div className="result-content spine-overlay-content">
            {/* 兌獎說明 */}
            {result.claimInstructions && (
              <div className="claim-info">
                <div className="claim-label">兌獎說明</div>
                <p className="claim-text">{result.claimInstructions}</p>
              </div>
            )}

            <button className="btn-primary result-close-btn" onClick={onClose}>
              太棒了！
            </button>
          </div>
        </div>
      </div>
    );
  }

  // 未中獎 - 保持原本設計
  return (
    <div className="result-overlay fade-in" onClick={onClose}>
      <div
        className="result-modal lose slide-up"
        onClick={e => e.stopPropagation()}
        ref={modalRef}
      >
        <div className="result-light" />
        <div className="result-content">
          <div className="result-icon lose-icon">🍀</div>
          <h2 className="result-title lose-title">再接再厲</h2>
          <p className="result-message">
            很可惜這次未中獎，<br />期待下次與幸運相遇！
          </p>
          <button className="btn-primary result-close-btn" onClick={onClose}>
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}

export default SpinResultModal;
